export const enum OrganisationStructureLevel {
  Organisation = 'organisationId',
  Country = 'countryId',
  Centre = 'centreId',
  Location = 'locationId',
}

export type OrganisationStructureFilter = {
  required?: OrganisationStructureLevel;
  forbidden?: OrganisationStructureLevel;
};
